/* NIBBLE & NABBLE — EVENTS CALENDAR (editor-safe, multi-instance) */
(function () {
  'use strict';

  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var DAYS = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

  function sameDay(a, b) {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  }

  function initCalendar(root) {
    if (!root || root.dataset.nnCalInit === '1') return;
    root.dataset.nnCalInit = '1';

    var events = [];
    var dataEl = root.querySelector('script[data-nn-events]');
    try { events = JSON.parse(dataEl ? dataEl.textContent : (root.dataset.events || '[]')); } catch (e) { events = []; }

    events.forEach(function (ev) { ev._d = ev.date ? new Date(String(ev.date).trim() + 'T00:00:00') : null; });
    events = events.filter(function (ev) { return ev._d && !isNaN(ev._d); });
    events.sort(function (a, b) { return a._d - b._d; });

    var grid = root.querySelector('[data-nn-cal-grid]') || root;
    var startSetting = root.dataset.defaultMonth;
    var view, mode = 'month';
    if (startSetting && /^\d{4}-\d{2}$/.test(startSetting)) {
      var p = startSetting.split('-');
      view = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, 1);
    } else if (events.length) {
      var today0 = new Date(); today0.setHours(0,0,0,0);
      var next = events.filter(function (ev) { return ev._d >= today0; })[0] || events[0];
      view = new Date(next._d.getFullYear(), next._d.getMonth(), 1);
    } else {
      var now = new Date();
      view = new Date(now.getFullYear(), now.getMonth(), 1);
    }
    if (window.matchMedia && window.matchMedia('(max-width: 600px)').matches) { mode = 'agenda'; }

    function eventsOn(date) { return events.filter(function (ev) { return sameDay(ev._d, date); }); }

    function renderAgenda() {
      var today = new Date(); today.setHours(0,0,0,0);
      var upcoming = events.filter(function (ev) { return ev._d >= today; });
      var list = upcoming.length ? upcoming : events;
      var html = '<div class="nn-cal__head"><span class="nn-cal__title">Upcoming</span><button type="button" class="nn-cal__toggle" data-cal-toggle>Month view</button></div><div class="nn-cal__agenda">';
      if (!list.length) {
        html += '<p class="nn-cal__agenda-empty">No events scheduled yet.</p>';
      } else {
        list.forEach(function (ev) {
          html += '<div class="nn-cal__agenda-row" data-cal-jump="' + ev._d.getFullYear() + '-' + (ev._d.getMonth()+1) + '-' + ev._d.getDate() + '">' +
            '<div class="nn-cal__agenda-date"><span>' + MONTHS[ev._d.getMonth()].slice(0,3) + '</span><strong>' + ev._d.getDate() + '</strong></div>' +
            '<div class="nn-cal__agenda-info"><p class="nn-cal__agenda-name">' + (ev.name || 'Event') + '</p><p class="nn-cal__agenda-loc">' + (ev.location || '') + (ev.start ? ' \u00b7 ' + ev.start : '') + '</p></div></div>';
        });
      }
      html += '</div>';
      grid.innerHTML = html;
    }

    function renderMonth() {
      var year = view.getFullYear(), month = view.getMonth();
      var startDow = new Date(year, month, 1).getDay();
      var daysInMonth = new Date(year, month + 1, 0).getDate();
      var today = new Date();

      var html = '<div class="nn-cal__head">' +
        '<button type="button" class="nn-cal__nav" data-cal-prev aria-label="Previous month">&#8249;</button>' +
        '<span class="nn-cal__title">' + MONTHS[month] + ' ' + year + '</span>' +
        '<button type="button" class="nn-cal__nav" data-cal-next aria-label="Next month">&#8250;</button></div>' +
        '<button type="button" class="nn-cal__toggle nn-cal__toggle--agenda" data-cal-toggle>List view</button>' +
        '<div class="nn-cal__grid nn-cal__dow">';
      DAYS.forEach(function (d) { html += '<div class="nn-cal__dow-cell">' + d + '</div>'; });
      html += '</div><div class="nn-cal__grid nn-cal__days">';
      for (var i = 0; i < startDow; i++) { html += '<div class="nn-cal__cell nn-cal__cell--empty"></div>'; }
      for (var day = 1; day <= daysInMonth; day++) {
        var cellDate = new Date(year, month, day);
        var dayEvents = eventsOn(cellDate);
        var cls = 'nn-cal__cell';
        if (dayEvents.length) cls += ' nn-cal__cell--has-event';
        if (sameDay(cellDate, today)) cls += ' nn-cal__cell--today';
        html += '<div class="' + cls + '"' + (dayEvents.length ? ' data-cal-jump="' + year + '-' + (month+1) + '-' + day + '" tabindex="0" role="button"' : '') + '>' +
          '<span class="nn-cal__num">' + day + '</span>' +
          (dayEvents.length ? '<span class="nn-cal__dot"></span>' + (dayEvents.length > 1 ? '<span class="nn-cal__count">' + dayEvents.length + '</span>' : '') : '') +
          '</div>';
      }
      html += '</div>';
      grid.innerHTML = html;
    }

    function render() { if (mode === 'agenda') { renderAgenda(); } else { renderMonth(); } }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-cal-toggle]')) { mode = (mode === 'month') ? 'agenda' : 'month'; render(); return; }
      if (e.target.closest('[data-cal-prev]')) { view.setMonth(view.getMonth() - 1); render(); return; }
      if (e.target.closest('[data-cal-next]')) { view.setMonth(view.getMonth() + 1); render(); return; }
      var jump = e.target.closest('[data-cal-jump]');
      if (jump) {
        var t = document.getElementById('nn-event-' + jump.dataset.calJump);
        if (t) {
          t.scrollIntoView({ behavior: 'smooth', block: 'center' });
          t.classList.add('nn-event-card--flash');
          setTimeout(function () { t.classList.remove('nn-event-card--flash'); }, 1400);
        }
      }
    });

    render();
    root.classList.add('nn-cal--ready');
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-nn-calendar]').forEach(initCalendar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Shopify theme editor: sections re-render via AJAX — re-init */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-nn-calendar]').forEach(function (el) { el.dataset.nnCalInit = ''; });
    initAll(e.target);
  });
  document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
})();
